var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.layout)?_c(_vm.layout,{tag:"component"}):_vm._e(),_vm._v(" "),(_vm.user)?_c('notification-permission-banner'):_vm._e()],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }